module.exports = __webpack_public_path__ + "static/12-f8076714b11201ad6638196b91229b0b.jpg";